import RestResource from '../rest.service';
import Service from '../api.service';

export default class StocksService extends RestResource {
  byArticle(campaign_id, variety_id, seller_id) {
    return Service.post(`stocks/articles`, { campaign_id, variety_id, seller_id });
  }

  byDistributor(campaign_id, distributor_id) {
    return Service.post('stocks/distributors', { campaign_id, distributor_id });
  }

  totalsByDistributor(campaign_id, distributor_id) {
    return Service.post('stocks/distributors/totals', { campaign_id, distributor_id });
  }

  varietiesSummary(campaign_id, distributor_id) {
    return Service.post('stocks/distributors/varieties', { campaign_id, distributor_id });
  }

  varietiesTotals(campaign_id, variety_id, seller_id) {
    return Service.post('stocks/articles/varieties', { campaign_id, variety_id, seller_id });
  }

  cropsTotals(campaign_id, variety_id, seller_id) {
    return Service.post('stocks/articles/crops', { campaign_id, variety_id, seller_id });
  }

  reportByDistributor(campaign_id, params) {
    return Service.get(`stocks/distributors/pdf/${campaign_id}`, { params: params, responseType: 'arraybuffer' })
      .then((res) => this.downloadPDF(res, params.filename))
      .catch(this.handleErrors);
  }

  reportByArticle(campaign_id, params) {
    return Service.get(`stocks/articles/pdf/${campaign_id}`, { params: params, responseType: 'arraybuffer' })
      .then((res) => this.downloadPDF(res, params.filename))
      .catch(this.handleErrors);
  }

  constructor() {
    super('stocks');
  }
}
